import { gql } from '@apollo/client';

export const LOAD_TENANTS = gql`
  query getTenants {
    getTenants {
      id
      name
      displayName
      contacts {
        name
        email
        phone
        type
      }
      meta {
        deletedOn
        addedOn
        disabled
        disabledOn
      }
    }
  }
`;
export const ADD_TENANTS = gql`
  mutation getTenants {
    id
    name
    displayName
  }
`;

export const GET_TENANT_BY_ID = gql`
  query getTenantById($id: ID!) {
    getTenantById(id: $id) {
      id
      name
      displayName
      timezone
      contacts {
        name
        email
        phone
        type
        website
        leadWebsite
        address
      }
      aliases {
        alias
        beginOn
        description
        additionalParameters
      }
      applicationSubscriptions {
        application
        licenseLevel
        features {
          name
          description
          enabled
          options
        }
      }
      tags {
        name
        value
      }
      publicWaterSystems {
        pwsId
        alias
        name
        beginOn
        endOn
      }
      location {
        longitude
        latitude
        zoom
      }
      meta {
        addedOn
        deletedOn
      }
    }
  }
`;

export const GET_API_CONFIG_BY_ID = gql`
  query getApiConfigByTenantId($id: ID!) {
    getApiConfigByTenantId(id: $id) {
      _id
      tenant {
        name
        id
        displayName
      }
      name
      key
      url
      collectorType
      enabled
      timezone
    }
  }
`;

export const GET_DATA_INTEGRATION_BY_ID = gql`
  query getDataIntegrationByTenantId($id: ID!) {
    getDataIntegrationByTenantId(id: $id) {
      _id
      tenant {
        name
        id
        displayName
      }
      esri {
        appId
        appSecret
        layers {
          layerName
          displayName
          layerNumber
          layerFieldMapping
          tags
          group
        }
      }
    }
  }
`;

export const DELETE_TENANTS = gql`
  mutation deleteTenant($id: ID!) {
    deleteTenant(id: $id) {
      name
      id
    }
  }
`;

export const DISABLE_TENANT = gql`
  mutation disableTenant($id: ID!) {
    disableTenant(id: $id) {
      id
      name
      meta {
        disabled
        disabledOn
      }
    }
  }
`;

export const ENABLE_TENANT = gql`
  mutation enableTenant($id: ID!) {
    enableTenant(id: $id) {
      id
      name
      meta {
        disabled
        disabledOn
      }
    }
  }
`;

export const UPDATE_TENANTS = gql`
  mutation updateTenant($id: ID!, $input: TenantInput!) {
    updateTenant(id: $id, input: $input) {
      id
      name
      aliases {
        alias
        beginOn
        description
        additionalParameters
      }
    }
  }
`;

export const UPDATE_TENANT_API_CONFIG = gql`
  mutation updateTenantApiConfig($id: ID!, $input: ApiConfigInput) {
    updateTenantApiConfig(id: $id, input: $input) {
      name
    }
  }
`;

export const UPDATE_TENANT_DATA_INT = gql`
  mutation updateTenantDataIntegration(
    $id: ID!
    $input: DataIntegrationInput!
  ) {
    updateTenantDataIntegration(id: $id, input: $input) {
      tenant {
        name
        displayName
        id
      }
      esri {
        appSecret
        appId
        layers {
          layerName
          displayName
        }
      }
    }
  }
`;

export const CREATE_API_CONFIG = gql`
  mutation addTenantApiConfig($input: ApiConfigInput) {
    addTenantApiConfig(input: $input) {
      name
    }
  }
`;

export const CREATE_DATA_INT = gql`
  mutation addTenantDataIntegration($input: DataIntegrationInput!) {
    addTenantDataIntegration(input: $input) {
      tenant {
        name
      }
    }
  }
`;

export const CREATE_TENANT = gql`
  mutation addTenant($input: TenantInput!) {
    addTenant(input: $input) {
      name
      id
    }
  }
`;

export const TENANT_STATUS_SUBSCRIPTION = gql`
  subscription TenantStatusUpdates($tenantId: ID) {
    tenantStatusUpdates(tenantId: $tenantId) {
      tenantId
      tenantName
      status
      message
      timestamp
      process
    }
  }
`;
